import { rgba } from 'polished';
import { createGlobalStyle } from 'styled-components';

import { type Theme } from './themes';

export const GlobalStyle = createGlobalStyle<{ theme?: Theme }>`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${({ theme }) => theme.fontFamily.SANS}, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    z-index: 0;
  }

  html,
  body {
    position: relative;
    overflow-x: hidden;
    min-height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
    color: ${({ theme }) => theme.fontColor.DEFAULT};
    line-height: ${({ theme }) => theme.lineHeight.DEFAULT};
    font-size: ${({ theme }) => theme.fontSize.DEFAULT};
    font-weight: ${({ theme }) => theme.fontWeight.NORMAL};
  }

  html.smoothScroll {
    scroll-behavior: smooth;
  }

  a {
    color: ${({ theme }) => theme.fontColor.DEFAULT};
    text-decoration: none;
    border-bottom: 1px solid ${({ theme }) => theme.highlightColor};
    background-color: transparent;
    transition: background-color ${({ theme }) => `${theme.animation.DURATION} ${theme.animation.EASING}`};

    &:hover {
      text-decoration: none;
      background-color: ${({ theme }) => rgba(theme.highlightColor, 0.3)};
    }

    &:active {
      background-color: ${({ theme }) => rgba(theme.highlightColor, 0.7)};
    }
  }

  .hexLogoLink {
    text-decoration: none;
    border-bottom: none;
  }

  p {
    font-size: ${({ theme }) => theme.fontSize.MEDIUM};
    line-height: ${({ theme }) => theme.lineHeight.MEDIUM};
    margin: 0;
  }

  .divider {
    height: 1px;
    margin: 25px 0;
    background-color: ${({ theme }) => rgba(theme.colors.BLACK, 0.1)};
  }

  hr {
    height: 1px;
    margin: 25px 0;
    border: none;
    background-color: ${({ theme }) => rgba(theme.colors.BLACK, 0.1)};
  }

  .emoji {
    margin: 0 7px 0 3px;
  }

  *::selection {
    background: ${({ theme }) => rgba(theme.highlightColor, 0.3)};
  }

  .toolTip {
    pointer-events: all !important;
    background: ${({ theme }) => theme.backgroundColor} !important;
    padding: 8px 10px !important;
    box-shadow: none !important;
    border-radius: 3px !important;
    z-index: 99999999999 !important;
    max-width: 215px !important;
    color: ${({ theme }) => theme.colors.WHITE} !important;
    font-size: ${({ theme }) => theme.fontSize.DEFAULT} !important;
    line-height: 20px !important;

    border: 1px solid ${({ theme }) => theme.borderColor.DEFAULT} !important;
    box-shadow: 0 4px 4px ${({ theme }) =>
      rgba(theme.colors.BLACK, 0.25)}, 0 0 54px ${({ theme }) =>
      theme.colors.BLACK},
      0 0 50px ${({ theme }) =>
        rgba(theme.borderColor.DEFAULT, 0.25)} !important;

    .react-tooltip-arrow {
      display: none !important;
    }
  }
`;
